interface Props {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  icon?: boolean
}

export default function SecondaryButton({ text, onClick, disabled, icon=false }: Props) {

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`hover:bg-[#FF609E] hover:text-white  hoverFilter focus:!outline-4 focus:!outline-[#8033FF]  w-full mt-[16px] mr-1 cursor-pointer inline-flex flex-row justify-center text-center rounded-full py-[12px] px-[28px] text-text-center text-black bg-white border-2 border-black ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {icon && <img src="/left-arrow.svg" alt="Arrow Right" className="ml-2 h-4 w-4 my-auto mr-1 " />} {text}
    </button>
  )

}
